<ion-content class="full-height">
    <form [formGroup]="reportForm" (ngSubmit)="onSubmit()" class="flex-column-with-footer flex-column-with-form">
        <h2 *ngIf="title" class="text-center">{{ title }}</h2>

        <lib-select
            [options]="issueOptions"
            label="What is the issue?"
            placeholder="Select"
            [form]="reportForm"
            controlName="what_was_the_issue" />
        <lib-textarea
            label="Details"
            placeholder="Tell us more about the problem"
            [form]="reportForm"
            controlName="details_of_report" />

        <div class="text-center ion-padding-bottom ion-padding-horizontal">
            <lib-button [disabled]="!reportForm.valid" type="submit" [expand]="true">
                {{ submitButtonText }}
            </lib-button>
        </div>
    </form>
</ion-content>
